import { optionStatusBin } from '../../../pages/daf/Adm/Dominios/utils/optionStatusBin';
import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemModuloSubmodulosExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => ({
      id: item.id,
      status: optionStatusBin.find((opt) => opt.value === item.status)?.label,
      submodulo: item.submodulo,
      descricao: item.descricao,
      itens: item.itens,
      modulo: item.moduloNome,
      usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
      dataRegistro: item.dataRegistro,
      dataUltimaAtualizacao: item.dataUltimaAtualizacao,
      usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
      nEdicoes: item.nEdicoes || 0,
    }));

    const mainSheet: ExportSheet = {
      name: 'Listagem de Submódulos',
      columns: {
        id: 'ID',
        status: 'Status',
        submodulo: 'Submódulo',
        descricao: 'Descrição',
        itens: 'Itens',
        modulo: 'Módulo',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        dataUltimaAtualizacao: 'Última Atualização',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
